import { object, ObjectSchema, string } from 'yup';

import { AddressValue } from '@client/api';

import { addressSourceValueSchema } from './AddressSourceValue.schema';
import { coordinateValueSchema } from './CoordinateValue.schema';
import { countryValueSchema } from './CountryValue.schema';

const schema: ObjectSchema<AddressValue> = object({
  streetName: string().required(),
  streetNumber: string().nullable(),
  streetAddress2: string().nullable(),
  zipCode: string().required(),
  zipPlace: string().required(),
  country: countryValueSchema.required(),
  source: addressSourceValueSchema.nullable().makeOptional(),
  coordinate: coordinateValueSchema.nullable().makeOptional(),
  streetAddress1: string(),
  municipality: string().required(),
  formattedAddress: string()
});

export { schema as addressValueSchema };
